import React from 'react'
import { QuestionInputProps } from '../../questionTypes'

export const DollarValueQuestion: React.FC<QuestionInputProps> = ({ question: { id: questionId }, value, onChange, readOnly = false }) => {
  // Accept digits + a single decimal point, max two decimal places. Reject (ignore)
  // input that would break those rules rather than silently truncating.
  const handleChange = (raw: string): void => {
    const digits = raw.replace(/[^0-9.]/g, '')
    const parts = digits.split('.')
    if (parts.length > 2) return
    if (parts.length === 2 && parts[1].length > 2) return
    onChange(digits)
  }

  return (
    <div className='survey-response-question__dollar'>
      <div className='survey-response-question__dollar-wrapper'>
        <span className='survey-response-question__dollar-sign'>$</span>
        <input
          id={`question-${questionId}`}
          type='text'
          inputMode='decimal'
          className='survey-response-question__dollar-input'
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          placeholder='0.00'
          readOnly={readOnly}
        />
      </div>
    </div>
  )
}
